import axios from 'axios'
import Utils from '../services/Utils'

export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).storage
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).storage
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    convertImageHeicToPng(file, callback) {
        const formData = new FormData()
        formData.append('file', file)
        axios.post(axios.defaults.storageApiUrl + 'file/convert/heic?lng=' + window.language,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Data-Type': 'image/heic',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
